import { Component } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { NbsextratorService } from './nbsextrator.service';

interface EmpresaExtrator {
  codEmpresa: number;
  nome: string;
  cnpj: string;
  codDealer: string;
  ambiente: string;
  ativo: boolean;
  rotulo: string;
  hashLinha?: string;
  situacao?: string;
  mensagem?: string;
}

interface OperacaoExtrator {
  codOperacao: number;
  descricao: string;
  contrato: number;
  horario: string;
  ativo: boolean;
  visualizarMonitor?: boolean;
  rotulo: string;
  codDealer?: string;
  hashLinha?: string;
  situacao?: string;
  mensagem?: string;
}

interface ConfiguracaoExtrator {
  tipoIntegracao: string;
  usaDataInicio: boolean;
  dataInicio: Date;
  urlHomologacao: string;
  urlProducao: string;
  idGrupoEmail: number;
  diasMonitor: number;
}

interface GrupoEmailExtrator {
  idGrupo: number;
  descricao: string;
}

interface FiltroMonitor {
  empresas: EmpresaExtrator[];
  status: string;
  tipoData: string;
  dataInicial: Date;
  dataFinal: Date;
  registro: string;
  descricao: string;
  tipoPessoa?: string;
}

interface BalcaoMonitor {
  codDealer: string;
  codMovimento: string;
  codEmpresa: number;
  nomeEmpresa: string;
  numero: string;
  serie: string;
  dataEmissao: string;
  vendedor: string;
  cpfVendedor: string;
  cliente: string;
  operacao: string;
  enviado: string;
  status: string;
  dataIntegracao: string;
  dataUltimaAtualizacao: string;
  errosEnvio: number;
  marca: string;
}

interface ColunaMonitor {
  campo: string;
  titulo: string;
  tipo?: string;
}

interface OperacaoMonitor {
  codOperacao: number;
  codDealer: string;
  codMovimento: string;
  codEmpresa: number;
  nomeEmpresa: string;
  partNumber: string;
  codProposta: string;
  statusProposta: string;
  numeroPedido: string;
  numeroOs: string;
  idNumeroOs: string;
  codFornecedor: string;
  sequencia: string;
  codEvento: string;
  statusEvento: string;
  codCliente: string;
  statusOs: string;
  codMtoc: string;
  enviado: string;
  status: string;
  dataIntegracao: string;
  dataUltimaAtualizacao: string;
  errosEnvio: number;
  marca: string;
}

interface OsMonitor {
  codDealer: string;
  codMovimento: string;
  codEmpresa: number;
  nomeEmpresa: string;
  numeroOs: string;
  idNumeroOs: string;
  descTipoOs: string;
  consultor: string;
  cliente: string;
  enviado: string;
  status: string;
  dataIntegracao: string;
  dataUltimaAtualizacao: string;
  errosEnvio: number;
  marca: string;
}

interface CompraMonitor {
  codDealer: string;
  codMovimento: string;
  codEmpresa: number;
  nomeEmpresa: string;
  codControle: string;
  numero: string;
  serie: string;
  dataEmissao: string;
  codCliente: string;
  cliente: string;
  operacao: string;
  enviado: string;
  status: string;
  dataIntegracao: string;
  dataUltimaAtualizacao: string;
  errosEnvio: number;
  marca: string;
}

interface ProdutivoMonitor {
  codDealer: string;
  codMovimento: string;
  codEmpresa: number;
  nomeEmpresa: string;
  codTecnico: string;
  nome: string;
  cpf: string;
  dataAdmissao: string;
  enviado: string;
  status: string;
  dataIntegracao: string;
  dataUltimaAtualizacao: string;
  errosEnvio: number;
  marca: string;
}

interface ClienteMonitor {
  codDealer: string;
  codMovimento: string;
  codEmpresa: number;
  nomeEmpresa: string;
  codCliente: string;
  nome: string;
  dataCadastro: string;
  tipoPessoa: string;
  enviado: string;
  status: string;
  dataIntegracao: string;
  dataUltimaAtualizacao: string;
  errosEnvio: number;
  marca: string;
}

interface DetalheCliente {
  chave: string;
  dataTentativa: string;
  descricaoEnvio: string;
  descricaoStatus: string;
  versao: string;
  mensagem: string;
  envio: string;
  retorno: string;
}

interface MovimentoExtrator {
  codMovimento: number;
  codOperacao: number;
  codEmpresa: number;
  empresa: string;
  registro: string;
  descricao: string;
  status: string;
  dataIntegracao: Date;
  dataUltimaAtualizacao: Date;
  errosEnvio: number;
}

interface CruzamentoExtrator {
  id: number;
  codCruzamento?: number;
  codDealer: string;
  codEmpresa: number;
  nomeDealer: string;
  codOperacao: number;
  operacao: string;
  ativo: boolean;
  configurado: boolean;
  configuracao: ConfiguracaoExtrator;
  hashLinha?: string;
  situacao?: string;
  mensagem?: string;
}

@Component({
  selector: 'app-nbsextrator',
  templateUrl: './nbsextrator.component.html',
  styleUrls: ['./nbsextrator.component.scss']
})
export class NbsextratorComponent {

  rows = 10;
  rowsPerPageOptions = [10, 20, 30];
  paginaTemplate = 'Mostrando {first} a {last} de {totalRecords} registros';

  empresas: EmpresaExtrator[] = [
    this.criarEmpresa(2, 'AVERSA HMB MATRIZ', '16.788.511/0001-50', '9998', 'Produção', true),
    this.criarEmpresa(3, 'AVERSA HMB AGUA STA', '52.084.225/0001-77', '9999', 'Homologação', true),
    this.criarEmpresa(31, 'Avec Campinas', '10.981.791/0001-31', '2', 'Produção', true),
    this.criarEmpresa(40, 'NBS São Paulo', '04.112.334/0001-20', '1001', 'Homologação', true),
    this.criarEmpresa(41, 'NBS Curitiba', '08.441.902/0001-55', '1002', 'Produção', true),
    this.criarEmpresa(42, 'NBS Recife', '12.908.331/0001-09', '1003', 'Homologação', false),
    this.criarEmpresa(43, 'NBS Porto Alegre', '33.120.884/0001-61', '1004', 'Produção', true),
    this.criarEmpresa(44, 'NBS Belo Horizonte', '27.650.119/0001-44', '1005', 'Produção', true),
    this.criarEmpresa(45, 'NBS Salvador', '19.334.770/0001-18', '1006', 'Homologação', true),
    this.criarEmpresa(46, 'NBS Brasília', '41.228.905/0001-73', '1007', 'Produção', false),
    this.criarEmpresa(47, 'NBS Fortaleza', '05.771.640/0001-90', '1008', 'Produção', true)
  ];

  operacoes: OperacaoExtrator[] = [
    this.criarOperacao(8, 'Clientes', 1, '', true),
    this.criarOperacao(12, 'Compra', 1, '', true),
    this.criarOperacao(13, 'Estoque', 1, '', true),
    this.criarOperacao(14, 'Item Estoque', 1, '', true),
    this.criarOperacao(15, 'Kardex', 1, '', true),
    this.criarOperacao(19, 'DEF', 1, '', true),
    this.criarOperacao(21, 'Feriado', 1, '', false),
    this.criarOperacao(23, 'Diagnóstico', 1, '08:00', true),
    this.criarOperacao(33, 'Ficha de Gerenciamento', 1, '', true),
    this.criarOperacao(35, 'Coaf', 1, '', true),
    this.criarOperacao(40, 'Leads', 1, '', true)
  ];

  cruzamentos: CruzamentoExtrator[] = [
    this.criarCruzamento(1, this.empresas[0], this.operacoes[0], true, 'https://hml.exemplo/clientes', 'https://prod.exemplo/clientes'),
    this.criarCruzamento(2, this.empresas[0], this.operacoes[1], true, '', 'https://prod.exemplo/compra'),
    this.criarCruzamento(3, this.empresas[0], this.operacoes[7], true),
    this.criarCruzamento(4, this.empresas[0], this.operacoes[6], false),
    this.criarCruzamento(5, this.empresas[0], this.operacoes[8], true, 'https://hml.exemplo/ficha'),
    this.criarCruzamento(6, this.empresas[0], this.operacoes[3], true, 'https://hml.exemplo/item', 'https://prod.exemplo/item'),
    this.criarCruzamento(7, this.empresas[0], this.operacoes[4], true),
    this.criarCruzamento(8, this.empresas[1], this.operacoes[0], true),
    this.criarCruzamento(9, this.empresas[1], this.operacoes[9], true, '', 'https://prod.exemplo/coaf'),
    this.criarCruzamento(10, this.empresas[2], this.operacoes[2], true),
    this.criarCruzamento(11, this.empresas[3], this.operacoes[10], false)
  ];

  proximoCruzamentoId = 12;

  statusMonitor = [
    { label: 'Pendente', value: 'Pendente' },
    { label: 'Sucesso', value: 'Sucesso' },
    { label: 'Rejeitado', value: 'Rejeitado' },
    { label: 'Bloqueado', value: 'Bloqueado' },
    { label: 'Parcialmente Rejeitado', value: 'Parcialmente Rejeitado' },
    { label: 'Erro', value: 'Erro' },
    { label: 'Atenção', value: 'Atenção' }
  ];

  tiposDataMonitor = [
    { label: 'Data Integração', value: 'integracao' },
    { label: 'Data última atualização', value: 'atualizacao' }
  ];

  statusCliente = [
    { label: 'Pendente', value: 'Pendente' },
    { label: 'Sucesso', value: 'Sucesso' },
    { label: 'Rejeitado', value: 'Rejeitado' },
    { label: 'Bloqueado', value: 'Bloqueado' },
    { label: 'Erro', value: 'Erro' }
  ];

  tiposDataCliente = [
    { label: 'Geração', value: 'integracao' },
    { label: 'Última atualização', value: 'atualizacao' }
  ];

  tiposDataCompra = [
    { label: 'Geração', value: 'integracao' },
    { label: 'Data emissão', value: 'emissao' },
    { label: 'Última atualização', value: 'atualizacao' }
  ];

  tiposDataOs = [
    { label: 'Geração', value: 'integracao' },
    { label: 'Cadastro', value: 'emissao' },
    { label: 'Última atualização', value: 'atualizacao' }
  ];

  tiposPessoaCliente = [
    { label: 'Tipo física', value: 'F' },
    { label: 'Tipo jurídica', value: 'J' }
  ];

  legendaStatus = [
    { status: 'Pendente', classe: 'pendente' },
    { status: 'Sucesso', classe: 'sucesso' },
    { status: 'Rejeitado', classe: 'rejeitado' },
    { status: 'Bloqueado', classe: 'bloqueado' },
    { status: 'Parcialmente Rejeitado', classe: 'parcial' },
    { status: 'Erro', classe: 'erro' },
    { status: 'Atenção', classe: 'atencao' }
  ];

  movimentos: MovimentoExtrator[] = [
    this.criarMovimento(1, 8, this.empresas[0], '8625200000141', 'ACACIA NEGOCIOS IMOBILIARIOS LTDA', 'Sucesso', this.data(6, 8, 3), this.data(6, 8, 3), 0),
    this.criarMovimento(2, 8, this.empresas[0], '13932095804', 'ADEMIR CARLOS GUERRA', 'Sucesso', this.data(6, 8, 1), this.data(6, 9, 33), 0),
    this.criarMovimento(3, 8, this.empresas[0], '2896969840', 'FABIANA CIA', 'Pendente', this.data(5, 14, 9), this.data(5, 14, 9), 1),
    this.criarMovimento(4, 8, this.empresas[1], '37294897002', 'MARCOS VINICIUS SOARES', 'Rejeitado', this.data(4, 10, 12), this.data(6, 11, 2), 2),
    this.criarMovimento(5, 8, this.empresas[2], '2940567582', 'VINICIOS LAZZARE', 'Bloqueado', this.data(3, 9, 40), this.data(6, 8, 9), 0),
    this.criarMovimento(6, 8, this.empresas[0], '51324150000191', 'TABELIAO DE NOTAS E PROTESTO', 'Erro', this.data(7, 8, 6), this.data(7, 8, 6), 3),
    this.criarMovimento(7, 8, this.empresas[3], '51321206600154', 'TAB. DE NOTAS E PROT. LETRAS', 'Atenção', this.data(2, 13, 31), this.data(6, 13, 31), 1),
    this.criarMovimento(8, 8, this.empresas[0], '1044', 'CLIENTE OFICINA CENTRO', 'Sucesso', this.data(7, 9, 15), this.data(7, 9, 20), 0),
    this.criarMovimento(9, 8, this.empresas[4], '2201', 'MARIA APARECIDA LIMA', 'Parcialmente Rejeitado', this.data(1, 16, 2), this.data(6, 16, 4), 1),
    this.criarMovimento(10, 8, this.empresas[0], '3308', 'TRANSPORTES HORIZONTE', 'Pendente', this.data(7, 11, 45), this.data(7, 11, 45), 0),
    this.criarMovimento(11, 8, this.empresas[6], '4412', 'COMERCIO DE PECAS SUL', 'Sucesso', this.data(6, 18, 10), this.data(7, 7, 55), 0),
    this.criarMovimento(12, 12, this.empresas[0], 'NF-1044', 'COMPRA DE PECAS', 'Sucesso', this.data(6, 10, 0), this.data(6, 10, 5), 0),
    this.criarMovimento(13, 12, this.empresas[1], 'NF-2208', 'COMPRA DE ACESSORIOS', 'Erro', this.data(5, 15, 22), this.data(5, 15, 30), 2),
    this.criarMovimento(14, 13, this.empresas[0], 'EST-88', 'SALDO DE ESTOQUE', 'Sucesso', this.data(7, 6, 12), this.data(7, 6, 12), 0),
    this.criarMovimento(15, 40, this.empresas[2], 'LD-19', 'LEAD SHOWROOM', 'Pendente', this.data(7, 12, 0), this.data(7, 12, 8), 0)
  ];

  filtroGeral = '';
  atualizando = false;
  private cargasPendentes = 0;
  empresasSincronizadas: EmpresaExtrator[] = [];
  operacoesSincronizadas: OperacaoExtrator[] = [];
  cruzamentosSincronizados: CruzamentoExtrator[] = [];
  cruzamentoEmEdicao: CruzamentoExtrator = null;
  empresasGrade: EmpresaExtrator[] = [];
  operacoesGrade: OperacaoExtrator[] = [];
  cruzamentosGrade: CruzamentoExtrator[] = [];
  movimentosGrade: { [codOperacao: number]: MovimentoExtrator[] } = {};
  movimentosMonitor: MovimentoExtrator[] = [];
  clientesCarregados: ClienteMonitor[] = [];
  clientesGrade: ClienteMonitor[] = [];
  produtivosCarregados: ProdutivoMonitor[] = [];
  produtivosGrade: ProdutivoMonitor[] = [];
  produtivoDetalhe: ProdutivoMonitor = null;
  comprasCarregados: CompraMonitor[] = [];
  comprasGrade: CompraMonitor[] = [];
  compraDetalhe: CompraMonitor = null;
  balcaoCarregados: BalcaoMonitor[] = [];
  balcaoGrade: BalcaoMonitor[] = [];
  balcaoDetalhe: BalcaoMonitor = null;
  ordensCarregados: OsMonitor[] = [];
  ordensGrade: OsMonitor[] = [];
  osDetalhe: OsMonitor = null;
  readonly codigosOperacaoExtra = [14, 15, 17, 18, 22, 24, 32, 33, 34];
  operacoesCarregadas: { [codigo: number]: OperacaoMonitor[] } = {};
  operacoesMonitorGrade: { [codigo: number]: OperacaoMonitor[] } = {};
  operacaoDetalhe: OperacaoMonitor = null;
  private operacaoReenvio = 8;
  private codAbaMonitor: number = null;
  exibirDetalheCliente = false;
  opcoesReenviar: MenuItem[] = [
    { label: 'Reenviar todos os bloqueados', command: () => this.confirmarReenvioLote('BLOQUEADOS') },
    { label: 'Reenviar todos com erro', command: () => this.confirmarReenvioLote('ERROS') }
  ];
  clienteDetalhe: ClienteMonitor = null;
  detalhesCliente: DetalheCliente[] = [];
  detalheSelecionado: DetalheCliente = null;

  filtrosMonitor: { [codOperacao: number]: FiltroMonitor } = {};
  movimentosExibidos: { [codOperacao: number]: MovimentoExtrator[] } = {};
  exibirFiltroMonitor = false;
  operacaoFiltro: number = null;
  filtroEdicao: FiltroMonitor = this.filtroVazio();

  ambientes = [
    { label: 'Homologação', value: 'Homologação' },
    { label: 'Produção', value: 'Produção' }
  ];

  exibirEmpresa = false;
  visualizandoEmpresa = true;
  empresaEdicao: EmpresaExtrator = null;

  exibirOperacao = false;
  visualizandoOperacao = false;
  operacaoEdicao: OperacaoExtrator = this.operacaoVazia();

  exibirCruzamento = false;
  visualizandoCruzamento = false;
  cruzamentoEdicaoId: number = null;
  empresaSelecionada: EmpresaExtrator = null;
  operacaoSelecionada: OperacaoExtrator = null;

  tiposIntegracao = [
    { label: 'Outro', value: 'Outro' },
    { label: 'FTP', value: 'FTP' },
    { label: 'Rest', value: 'Rest' },
    { label: 'Soap', value: 'Soap' },
    { label: 'Diretório', value: 'Diretório' },
    { label: 'SFTP', value: 'SFTP' }
  ];

  exibirConfiguracao = false;
  exibirDiasMonitor = false;
  diasMonitorEdicao = 30;
  limpezaModo = 'PERIODO';
  limpezaInicio: Date = null;
  limpezaFim: Date = null;
  limpezaResultado = '';
  cruzamentoConfiguracao: CruzamentoExtrator = null;
  configuracaoEdicao: ConfiguracaoExtrator = this.configuracaoPadrao();
  gruposEmail: GrupoEmailExtrator[] = [];

  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private extratorService: NbsextratorService
  ) {
    this.operacoes.forEach(operacao => this.prepararMonitor(operacao.codOperacao));
    this.filtrosMonitor[8] = this.filtroClientePadrao();
    this.filtrosMonitor[9] = this.filtroClientePadrao();
    this.filtrosMonitor[12] = this.filtroClientePadrao();
    this.filtrosMonitor[7] = this.filtroClientePadrao();
    this.filtrosMonitor[10] = this.filtroClientePadrao();
    this.codigosOperacaoExtra.forEach(codigo => this.filtrosMonitor[codigo] = this.filtroClientePadrao());
    this.aplicarFiltroGeral();
    this.carregarEmpresas();
    this.carregarOperacoes();
    this.carregarCruzamentos();
  }

  atualizar(): void {
    this.carregarEmpresas();
    this.carregarOperacoes();
    this.carregarCruzamentos();
    this.carregarMonitorSelecionado();
  }

  private carregarMonitorSelecionado(): void {
    if (this.temEmpresas(8)) {
      this.carregarClientes();
    }
    if (this.temEmpresas(9)) {
      this.carregarProdutivos();
    }
    if (this.temEmpresas(12)) {
      this.carregarCompras();
    }
    if (this.temEmpresas(7)) {
      this.carregarBalcao();
    }
    if (this.temEmpresas(10)) {
      this.carregarOs();
    }
    this.codigosOperacaoExtra.forEach(codigo => {
      if (this.temEmpresas(codigo)) {
        this.carregarOperacaoExtra(codigo);
      }
    });
  }

  private temEmpresas(codOperacao: number): boolean {
    const filtro = this.filtrosMonitor[codOperacao];
    return !!(filtro && filtro.empresas && filtro.empresas.length);
  }

  guardarAbaMonitor(indice: number): void {
    const operacao = this.operacoesMonitor[indice];
    this.codAbaMonitor = operacao ? operacao.codOperacao : null;
  }

  get indiceMonitor(): number {
    if (this.codAbaMonitor == null) {
      return 0;
    }
    const indice = this.operacoesMonitor.findIndex(item => item.codOperacao === this.codAbaMonitor);
    return indice < 0 ? 0 : indice;
  }

  filtrarGeral(valor: string): void {
    this.filtroGeral = valor || '';
    this.aplicarFiltroGeral();
  }

  get empresasAtivas(): EmpresaExtrator[] {
    return this.empresas.filter(item => item.ativo);
  }

  monitorMovimento(codOperacao: number): boolean {
    return codOperacao === 8 || codOperacao === 9 || codOperacao === 12 || codOperacao === 7 || codOperacao === 10;
  }

  operacaoExtra(codOperacao: number): boolean {
    return this.codigosOperacaoExtra.indexOf(codOperacao) >= 0;
  }

  monitorReal(codOperacao: number): boolean {
    return this.monitorMovimento(codOperacao) || this.operacaoExtra(codOperacao);
  }

  mensagemGrade(codOperacao: number): string {
    const filtro = this.filtrosMonitor[codOperacao];
    return filtro && filtro.empresas && filtro.empresas.length
      ? 'Nenhum registro encontrado.'
      : 'Selecione ao menos uma empresa no filtro.';
  }

  opcoesTipoData(codOperacao: number): { label: string, value: string }[] {
    if (codOperacao === 12 || codOperacao === 7) {
      return this.tiposDataCompra;
    }
    if (codOperacao === 10) {
      return this.tiposDataOs;
    }
    return this.monitorReal(codOperacao) ? this.tiposDataCliente : this.tiposDataMonitor;
  }

  abrirFiltroMonitor(codOperacao: number): void {
    const atual = this.filtrosMonitor[codOperacao] || (this.monitorReal(codOperacao) ? this.filtroClientePadrao() : this.filtroVazio());
    this.operacaoFiltro = codOperacao;
    this.filtroEdicao = {
      ...atual,
      empresas: atual.empresas ? atual.empresas.slice() : [],
      dataInicial: atual.dataInicial ? new Date(atual.dataInicial) : null,
      dataFinal: atual.dataFinal ? new Date(atual.dataFinal) : null
    };
    this.exibirFiltroMonitor = true;
  }

  confirmarFiltroMonitor(): void {
    if (this.filtroEdicao.dataInicial && this.filtroEdicao.dataFinal
      && this.inicioDoDia(this.filtroEdicao.dataFinal) < this.inicioDoDia(this.filtroEdicao.dataInicial)) {
      this.avisar('A data final deve ser maior ou igual à data inicial.');
      return;
    }

    if (this.monitorReal(this.operacaoFiltro) && ((this.filtroEdicao.dataInicial && !this.filtroEdicao.dataFinal) || (!this.filtroEdicao.dataInicial && this.filtroEdicao.dataFinal))) {
      this.avisar('Informe a data inicial e a data final.');
      return;
    }

    this.filtrosMonitor[this.operacaoFiltro] = { ...this.filtroEdicao };
    if (this.operacaoFiltro === 8) {
      this.carregarClientes();
    } else if (this.operacaoFiltro === 9) {
      this.carregarProdutivos();
    } else if (this.operacaoFiltro === 12) {
      this.carregarCompras();
    } else if (this.operacaoFiltro === 7) {
      this.carregarBalcao();
    } else if (this.operacaoFiltro === 10) {
      this.carregarOs();
    } else if (this.operacaoExtra(this.operacaoFiltro)) {
      this.carregarOperacaoExtra(this.operacaoFiltro);
    } else {
      this.filtrarMonitor(this.operacaoFiltro);
    }
    this.exibirFiltroMonitor = false;
  }

  limparFiltroMonitor(): void {
    this.filtroEdicao = this.filtroVazio();
    this.filtrosMonitor[this.operacaoFiltro] = this.filtroVazio();
    if (this.operacaoFiltro === 8) {
      this.carregarClientes();
    } else if (this.operacaoFiltro === 9) {
      this.carregarProdutivos();
    } else if (this.operacaoFiltro === 12) {
      this.carregarCompras();
    } else if (this.operacaoFiltro === 7) {
      this.carregarBalcao();
    } else if (this.operacaoFiltro === 10) {
      this.carregarOs();
    } else if (this.operacaoExtra(this.operacaoFiltro)) {
      this.carregarOperacaoExtra(this.operacaoFiltro);
    } else {
      this.filtrarMonitor(this.operacaoFiltro);
    }
    this.exibirFiltroMonitor = false;
  }

  filtrarMonitor(codOperacao: number): void {
    const filtro = this.filtrosMonitor[codOperacao];
    this.movimentosExibidos[codOperacao] = this.movimentos.filter(item => this.movimentoAtendeFiltro(item, codOperacao, filtro));
    this.movimentosExibidos = { ...this.movimentosExibidos };
    this.aplicarFiltroGeral();
  }

  abrirEmpresa(registro: EmpresaExtrator): void {
    this.visualizandoEmpresa = true;
    this.empresaEdicao = { ...registro };
    this.exibirEmpresa = true;
  }

  habilitarEdicaoEmpresa(): void {
    this.visualizandoEmpresa = false;
  }

  get tituloEmpresa(): string {
    return this.visualizandoEmpresa ? 'Visualizar' : 'Editar';
  }

  salvarEmpresa(): void {
    if (!this.empresaEdicao.codDealer) {
      this.avisar('Empresa sem código de dealer.');
      return;
    }
    const ambiente = this.empresaEdicao.ambiente === 'Homologação' ? 'H'
      : this.empresaEdicao.ambiente === 'Produção' ? 'P'
      : this.empresaEdicao.ambiente;
    this.extratorService.alterarEmpresa(null, this.empresaEdicao.codDealer, this.empresaEdicao.codEmpresa, {
      ambiente,
      ativo: this.empresaEdicao.ativo,
      hashLinha: this.empresaEdicao.hashLinha
    }).subscribe(() => {
      this.exibirEmpresa = false;
      this.mensagem('Alteração registrada. Ela será aplicada na revenda quando o serviço confirmar.');
      this.carregarEmpresas();
    }, (erro) => {
      const texto = erro && erro.error ? erro.error : 'Não foi possível registrar a alteração.';
      this.avisar(typeof texto === 'string' ? texto : 'Não foi possível registrar a alteração.');
    });
  }

  situacaoEmpresa(empresa: EmpresaExtrator): string {
    const situacoes = {
      PENDENTE: 'Pendente de envio',
      RECEBIDO: 'Recebida pelo serviço',
      ERRO: 'Erro na execução',
      CONFLITO: 'Conflito com a revenda'
    };
    return situacoes[empresa.situacao] || '';
  }

  private carregarEmpresas(): void {
    this.iniciarCarga();
    this.extratorService.listarEmpresas().subscribe(empresas => {
      this.empresasSincronizadas = (empresas || []).map(item => this.empresaDaRevend(item));
      this.aplicarFiltroGeral();
      this.finalizarCarga();
    }, () => {
      this.finalizarCarga();
      this.avisar('Não foi possível consultar as empresas sincronizadas.');
    });
  }

  get empresasParaCruzamento(): EmpresaExtrator[] {
    return this.empresasSincronizadas.filter(item => !!item.hashLinha);
  }

  get operacoesMonitor(): OperacaoExtrator[] {
    return this.operacoesSincronizadas.filter(item => item.visualizarMonitor);
  }

  get operacoesParaCruzamento(): OperacaoExtrator[] {
    if (!this.empresaSelecionada) {
      return [];
    }
    return this.operacoesSincronizadas.filter(item => !!item.hashLinha);
  }

  private carregarCruzamentos(): void {
    this.iniciarCarga();
    this.extratorService.listarCruzamentos().subscribe(cruzamentos => {
      this.cruzamentosSincronizados = (cruzamentos || []).map(item => this.cruzamentoDaRevend(item));
      this.aplicarFiltroGeral();
      this.finalizarCarga();
    }, () => {
      this.finalizarCarga();
      this.avisar('Não foi possível consultar os cruzamentos sincronizados.');
    });
  }

  private configuracaoDaRevend(item: any): ConfiguracaoExtrator {
    if (!item || (!item.configurado && !item.urlHomologacao && !item.urlProducao && !item.tipoIntegracao && !item.idGrupoEmail)) {
      return null;
    }
    return {
      tipoIntegracao: item.tipoIntegracao || 'Outro',
      usaDataInicio: !!item.usaDataInicio,
      dataInicio: this.dataLocal(item.dataInicio),
      urlHomologacao: item.urlHomologacao || '',
      urlProducao: item.urlProducao || '',
      idGrupoEmail: item.idGrupoEmail || null,
      diasMonitor: item.diasMonitor > 0 ? item.diasMonitor : 30
    };
  }

  private dataLocal(valor: string): Date {
    if (!valor || valor.length < 10) {
      return null;
    }
    const partes = valor.substring(0, 10).split('-');
    return new Date(Number(partes[0]), Number(partes[1]) - 1, Number(partes[2]));
  }

  private cruzamentoDaRevend(item: any): CruzamentoExtrator {
    return {
      id: item.codCruzamento,
      codCruzamento: item.codCruzamento,
      codDealer: item.codDealer,
      codEmpresa: item.codEmpresa,
      nomeDealer: item.nomeEmpresa,
      codOperacao: item.codOperacao,
      operacao: item.descricaoOperacao,
      ativo: item.ativo,
      configurado: item.configurado,
      configuracao: this.configuracaoDaRevend(item),
      hashLinha: item.hashLinha,
      situacao: item.situacao,
      mensagem: item.mensagem
    };
  }

  private carregarOperacoes(): void {
    this.iniciarCarga();
    this.extratorService.listarOperacoes().subscribe(operacoes => {
      this.operacoesSincronizadas = (operacoes || []).map(item => this.operacaoDaRevend(item));
      this.aplicarFiltroGeral();
      this.finalizarCarga();
    }, () => {
      this.finalizarCarga();
      this.avisar('Não foi possível consultar as operações sincronizadas.');
    });
  }

  private operacaoDaRevend(item: any): OperacaoExtrator {
    return {
      codOperacao: item.codOperacao,
      descricao: item.descricao,
      contrato: item.contrato,
      horario: item.horario || '',
      ativo: item.ativo,
      visualizarMonitor: !!item.visualizarMonitor,
      rotulo: item.codOperacao + ' - ' + item.descricao,
      codDealer: item.codDealer,
      hashLinha: item.hashLinha,
      situacao: item.situacao,
      mensagem: item.mensagem
    };
  }

  private iniciarCarga(): void {
    this.cargasPendentes++;
    this.atualizando = true;
  }

  private finalizarCarga(): void {
    this.cargasPendentes--;
    if (this.cargasPendentes < 1) {
      this.cargasPendentes = 0;
      this.atualizando = false;
    }
  }

  private empresaDaRevend(item: any): EmpresaExtrator {
    const ambiente = item.ambiente === 'H' ? 'Homologação' : item.ambiente === 'P' ? 'Produção' : item.ambiente;
    return {
      codEmpresa: item.codEmpresa,
      nome: item.nome,
      cnpj: item.cnpj,
      codDealer: item.codDealer,
      ambiente,
      ativo: item.ativo,
      rotulo: item.codDealer + ' - ' + item.codEmpresa + ' - ' + item.nome,
      hashLinha: item.hashLinha,
      situacao: item.situacao,
      mensagem: item.mensagem
    };
  }

  abrirOperacao(registro?: OperacaoExtrator): void {
    this.visualizandoOperacao = !!registro;
    this.operacaoEdicao = registro ? { ...registro } : this.operacaoVazia();
    if (!registro) {
      this.operacaoEdicao.codDealer = this.dealerDaNovaOperacao();
    }
    this.exibirOperacao = true;
  }

  habilitarEdicaoOperacao(): void {
    this.visualizandoOperacao = false;
  }

  get tituloOperacao(): string {
    if (!this.operacaoEdicao.rotulo) {
      return 'Nova operação';
    }
    return this.visualizandoOperacao ? 'Visualizar' : 'Editar';
  }

  get codigoOperacaoDesabilitado(): boolean {
    return this.visualizandoOperacao || !!this.operacaoEdicao.rotulo;
  }

  salvarOperacao(): void {
    const operacao = this.operacaoEdicao;
    const editando = !!operacao.rotulo;

    if (!operacao.codDealer) {
      operacao.codDealer = this.dealerDaNovaOperacao();
    }
    if (!operacao.codDealer) {
      this.avisar('Nenhuma empresa sincronizada para registrar a operação.');
      return;
    }

    if (!operacao.codOperacao || !operacao.descricao || !operacao.descricao.trim()) {
      this.avisar('Informe o código e a descrição da operação.');
      return;
    }

    if (operacao.codOperacao === 23 && operacao.horario && !/^\d{2}:\d{2}$/.test(operacao.horario.trim())) {
      this.avisar('O horário da operação Diagnóstico deve estar no formato HH:MM.');
      return;
    }

    const corpo = {
      codOperacao: operacao.codOperacao,
      descricao: operacao.descricao.trim(),
      ativo: operacao.ativo,
      horario: operacao.codOperacao === 23 ? (operacao.horario || '').trim() : (operacao.horario || ''),
      hashLinha: operacao.hashLinha,
      visualizarMonitor: !!operacao.visualizarMonitor
    };
    const atual = editando
      ? this.operacoesSincronizadas.find(item => item.codOperacao === operacao.codOperacao)
      : null;
    const mudouRevenda = !atual
      || atual.descricao !== corpo.descricao
      || atual.ativo !== corpo.ativo
      || (atual.horario || '') !== (corpo.horario || '');
    const pedido = editando
      ? this.extratorService.alterarOperacao(operacao.codDealer, operacao.codOperacao, corpo)
      : this.extratorService.incluirOperacao(operacao.codDealer, corpo);

    pedido.subscribe(() => {
      this.exibirOperacao = false;
      this.mensagem(!editando
        ? 'Inclusão registrada. Ela será gravada em PORTAL_OPER quando o serviço confirmar.'
        : mudouRevenda
          ? 'Alteração registrada. Ela será aplicada na revenda quando o serviço confirmar.'
          : 'A exibição no Monitor foi atualizada.');
      this.carregarOperacoes();
    }, (erro) => this.avisarResposta(erro, 'Não foi possível registrar a operação.'));
  }

  confirmarExclusaoOperacao(registro: OperacaoExtrator): void {
    if (!registro.hashLinha) {
      this.avisar('A inclusão ainda está pendente na revenda.');
      return;
    }

    this.confirmationService.confirm({
      message: `Deseja excluir a operação ${registro.codOperacao} - ${registro.descricao}?`,
      header: 'Excluir operação',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Excluir',
      rejectLabel: 'Cancelar',
      acceptButtonStyleClass: 'p-button-danger',
      accept: () => {
        const codDealer = registro.codDealer || this.dealerDaNovaOperacao();
        if (!codDealer) {
          this.avisar('Nenhuma empresa sincronizada para registrar a operação.');
          return;
        }
        this.extratorService.excluirOperacao(codDealer, registro.codOperacao, registro.hashLinha).subscribe(() => {
          this.mensagem('Exclusão registrada. Ela será aplicada na revenda quando o serviço confirmar.');
          this.carregarOperacoes();
        }, (erro) => this.avisarResposta(erro, 'Não foi possível excluir a operação.'));
      }
    });
  }

  situacaoOperacao(operacao: OperacaoExtrator): string {
    const situacoes = {
      PENDENTE: 'Pendente de envio',
      RECEBIDO: 'Recebida pelo serviço',
      ERRO: 'Erro na execução',
      CONFLITO: 'Conflito com a revenda'
    };
    return situacoes[operacao.situacao] || '';
  }

  situacaoCruzamento(cruzamento: CruzamentoExtrator): string {
    const situacoes = {
      PENDENTE: 'Pendente de envio',
      RECEBIDO: 'Recebida pelo serviço',
      ERRO: 'Erro na execução',
      CONFLITO: 'Conflito com a revenda'
    };
    return situacoes[cruzamento.situacao] || '';
  }

  abrirCruzamento(registro?: CruzamentoExtrator): void {
    this.visualizandoCruzamento = !!registro;
    this.cruzamentoEmEdicao = registro || null;
    this.cruzamentoEdicaoId = registro ? registro.codCruzamento : null;
    this.empresaSelecionada = registro
      ? this.empresasSincronizadas.find(item => item.codEmpresa === registro.codEmpresa && item.codDealer === registro.codDealer)
      : null;
    this.operacaoSelecionada = registro
      ? this.operacoesSincronizadas.find(item => item.codOperacao === registro.codOperacao)
      : null;
    this.exibirCruzamento = true;
  }

  habilitarEdicaoCruzamento(): void {
    this.visualizandoCruzamento = false;
  }

  get tituloCruzamento(): string {
    if (!this.cruzamentoEdicaoId) {
      return 'Cadastrar cruzamento';
    }
    return this.visualizandoCruzamento ? 'Visualizar' : 'Editar';
  }

  salvarCruzamento(): void {
    if (!this.empresaSelecionada || !this.operacaoSelecionada) {
      this.avisar('Selecione a empresa e a operação.');
      return;
    }
    if (!this.empresaSelecionada.codDealer) {
      this.avisar('Empresa sem código de dealer.');
      return;
    }

    const duplicado = this.cruzamentosSincronizados.some(item =>
      item.codCruzamento !== this.cruzamentoEdicaoId &&
      item.codDealer === this.empresaSelecionada.codDealer &&
      item.codEmpresa === this.empresaSelecionada.codEmpresa &&
      item.codOperacao === this.operacaoSelecionada.codOperacao
    );
    if (duplicado) {
      this.avisar('Esta empresa já está cruzada com a operação selecionada.');
      return;
    }

    const corpo = {
      codEmpresa: this.empresaSelecionada.codEmpresa,
      codOperacao: this.operacaoSelecionada.codOperacao,
      ativo: false,
      hashLinha: this.cruzamentoEmEdicao ? this.cruzamentoEmEdicao.hashLinha : ''
    };
    const pedido = this.cruzamentoEdicaoId
      ? this.extratorService.alterarCruzamento(this.empresaSelecionada.codDealer, this.cruzamentoEdicaoId, corpo)
      : this.extratorService.incluirCruzamento(this.empresaSelecionada.codDealer, corpo);

    pedido.subscribe(() => {
      this.exibirCruzamento = false;
      this.mensagem(this.cruzamentoEdicaoId
        ? 'Alteração registrada. Ela será aplicada na revenda quando o serviço confirmar.'
        : 'Inclusão registrada. Ela será gravada na revenda quando o serviço confirmar.');
      this.carregarCruzamentos();
    }, (erro) => this.avisarResposta(erro, 'Não foi possível registrar o cruzamento.'));
  }

  confirmarExclusaoCruzamento(registro: CruzamentoExtrator): void {
    if (!registro.codCruzamento || !registro.hashLinha) {
      this.avisar('Este cruzamento ainda não foi sincronizado.');
      return;
    }

    this.confirmationService.confirm({
      message: `Deseja excluir o cruzamento de ${registro.nomeDealer} com ${registro.operacao}?`,
      header: 'Excluir cruzamento',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Excluir',
      rejectLabel: 'Cancelar',
      acceptButtonStyleClass: 'p-button-danger',
      accept: () => {
        this.extratorService.excluirCruzamento(registro.codDealer, registro.codCruzamento, registro.hashLinha).subscribe(() => {
          this.mensagem('Exclusão registrada. Ela será aplicada na revenda quando o serviço confirmar.');
          this.carregarCruzamentos();
        }, (erro) => this.avisarResposta(erro, 'Não foi possível excluir o cruzamento.'));
      }
    });
  }

  definirAtivoCruzamento(registro: CruzamentoExtrator, ativo: boolean): void {
    if (ativo && !registro.configurado) {
      this.avisar('A operação ainda não foi configurada.');
      return;
    }
    if (!registro.codCruzamento || !registro.hashLinha) {
      this.avisar('Este cruzamento ainda não foi sincronizado.');
      return;
    }

    this.extratorService.alterarCruzamento(registro.codDealer, registro.codCruzamento, {
      codEmpresa: registro.codEmpresa,
      codOperacao: registro.codOperacao,
      ativo,
      hashLinha: registro.hashLinha
    }).subscribe(() => {
      this.mensagem(ativo
        ? 'Ativação registrada. Ela será aplicada na revenda quando o serviço confirmar.'
        : 'Desativação registrada. Ela será aplicada na revenda quando o serviço confirmar.');
      this.carregarCruzamentos();
    }, (erro) => this.avisarResposta(erro, 'Não foi possível alterar o cruzamento.'));
  }

  abrirConfiguracao(registro: CruzamentoExtrator): void {
    this.cruzamentoConfiguracao = registro;
    this.gruposEmail = [];
    const origem = registro.configuracao || this.configuracaoPadrao();
    this.configuracaoEdicao = {
      ...origem,
      dataInicio: origem.dataInicio ? new Date(origem.dataInicio) : null
    };
    this.exibirDiasMonitor = false;
    this.exibirConfiguracao = true;
    const dealer = registro.codDealer;
    this.extratorService.listarGruposEmail(dealer).subscribe(grupos => {
      if (this.cruzamentoConfiguracao && this.cruzamentoConfiguracao.codDealer === dealer) {
        this.gruposEmail = grupos || [];
      }
    }, () => this.avisar('Não foi possível consultar os grupos de e-mail.'));
  }

  abrirDiasMonitor(): void {
    this.diasMonitorEdicao = this.configuracaoEdicao.diasMonitor > 0 ? this.configuracaoEdicao.diasMonitor : 30;
    this.limpezaModo = 'PERIODO';
    this.limpezaInicio = null;
    this.limpezaFim = null;
    this.limpezaResultado = '';
    this.exibirDiasMonitor = true;
  }

  confirmarDiasMonitor(): void {
    const dias = Number(this.diasMonitorEdicao);
    if (!Number.isInteger(dias) || dias < 1 || dias > 365) {
      this.avisar('Informe uma quantidade de dias entre 1 e 365.');
      return;
    }
    this.configuracaoEdicao.diasMonitor = dias;
    this.exibirDiasMonitor = false;
  }

  confirmarLimpezaMonitor(): void {
    const cruzamento = this.cruzamentoConfiguracao;
    if (!cruzamento || !cruzamento.codDealer || cruzamento.codEmpresa == null || !this.monitorReal(cruzamento.codOperacao)) {
      this.avisar('Esta operação não tem cópia no Monitor.');
      return;
    }
    if (this.limpezaModo === 'PERIODO') {
      if (!this.limpezaInicio || !this.limpezaFim) {
        this.avisar('Informe a data inicial e a data final.');
        return;
      }
      if (this.inicioDoDia(this.limpezaFim) < this.inicioDoDia(this.limpezaInicio)) {
        this.avisar('A data final deve ser maior ou igual à data inicial.');
        return;
      }
    }
    const rotulo = `${cruzamento.codDealer} - ${cruzamento.codEmpresa} - ${cruzamento.nomeDealer} / ${cruzamento.operacao}`;
    let mensagem = `Deixar apenas o último detalhe de cada movimento de ${rotulo}? A grade do movimento permanece. A cópia do Oracle na revenda permanece.`;
    if (this.limpezaModo === 'PERIODO') {
      mensagem = `Excluir do Monitor os movimentos de ${rotulo} com data de integração de ${this.dataBr(this.limpezaInicio)} a ${this.dataBr(this.limpezaFim)}, e os detalhes desses movimentos? A cópia do Oracle na revenda permanece. Registro fora da janela de dias permanece apagado.`;
    } else if (this.limpezaModo === 'TUDO') {
      mensagem = `Excluir todos os movimentos e detalhes de ${rotulo} na cópia do Monitor? A cópia do Oracle na revenda permanece. A grade volta a ser preenchida depois de reiniciar o serviço, só com a primeira janela.`;
    }
    this.confirmationService.confirm({
      message: mensagem,
      header: 'Limpar cópia do Monitor',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Excluir',
      rejectLabel: 'Cancelar',
      acceptButtonStyleClass: 'p-button-danger',
      accept: () => this.enviarLimpezaMonitor()
    });
  }

  private enviarLimpezaMonitor(): void {
    const cruzamento = this.cruzamentoConfiguracao;
    if (!cruzamento) {
      return;
    }
    this.limpezaResultado = '';
    this.extratorService.limparMonitor(cruzamento.codDealer, {
      codEmpresa: cruzamento.codEmpresa,
      codOperacao: cruzamento.codOperacao,
      modo: this.limpezaModo,
      dataInicial: this.dataIso(this.limpezaInicio),
      dataFinal: this.dataIso(this.limpezaFim)
    }).subscribe(resultado => {
      const movimentos = resultado && resultado.movimentos ? resultado.movimentos : 0;
      const detalhes = resultado && resultado.detalhes ? resultado.detalhes : 0;
      this.limpezaResultado = this.limpezaModo === 'ULTIMO'
        ? `Detalhes removidos: ${detalhes}.`
        : `Movimentos removidos: ${movimentos}. Detalhes removidos: ${detalhes}.`;
      this.mensagem('Cópia do Monitor atualizada. ' + this.limpezaResultado);
      this.recarregarMonitor(cruzamento.codOperacao);
    }, (erro) => this.avisarResposta(erro, 'Não foi possível limpar a cópia do Monitor.'));
  }

  private recarregarMonitor(codOperacao: number): void {
    if (!this.temEmpresas(codOperacao)) {
      return;
    }
    if (codOperacao === 8) {
      this.carregarClientes();
    } else if (codOperacao === 9) {
      this.carregarProdutivos();
    } else if (codOperacao === 12) {
      this.carregarCompras();
    } else if (codOperacao === 7) {
      this.carregarBalcao();
    } else if (codOperacao === 10) {
      this.carregarOs();
    } else if (this.operacaoExtra(codOperacao)) {
      this.carregarOperacaoExtra(codOperacao);
    }
  }

  private dataBr(data: Date): string {
    if (!data) {
      return '';
    }
    const dois = (numero: number) => (numero < 10 ? '0' : '') + numero;
    return dois(data.getDate()) + '/' + dois(data.getMonth() + 1) + '/' + data.getFullYear();
  }

  salvarConfiguracao(): void {
    if (this.configuracaoEdicao.usaDataInicio && !this.configuracaoEdicao.dataInicio) {
      this.avisar('Informe a data para início do envio.');
      return;
    }
    if (!this.cruzamentoConfiguracao || !this.cruzamentoConfiguracao.codCruzamento || !this.cruzamentoConfiguracao.hashLinha) {
      this.avisar('Este cruzamento ainda não foi sincronizado.');
      return;
    }
    if (!this.configuracaoEdicao.idGrupoEmail) {
      this.avisar('Selecione o grupo de e-mail.');
      return;
    }

    this.extratorService.configurarCruzamento(this.cruzamentoConfiguracao.codDealer, this.cruzamentoConfiguracao.codCruzamento, {
      hashLinha: this.cruzamentoConfiguracao.hashLinha,
      tipoIntegracao: this.configuracaoEdicao.tipoIntegracao,
      usaDataInicio: this.configuracaoEdicao.usaDataInicio,
      dataInicio: this.dataIso(this.configuracaoEdicao.dataInicio),
      urlHomologacao: this.configuracaoEdicao.urlHomologacao || '',
      urlProducao: this.configuracaoEdicao.urlProducao || '',
      idGrupoEmail: this.configuracaoEdicao.idGrupoEmail,
      diasMonitor: this.configuracaoEdicao.diasMonitor > 0 ? this.configuracaoEdicao.diasMonitor : 30
    }).subscribe(() => {
      this.exibirConfiguracao = false;
      this.mensagem('Configuração registrada. Ela será aplicada na revenda quando o serviço confirmar.');
      this.carregarCruzamentos();
    }, (erro) => this.avisarResposta(erro, 'Não foi possível enviar a configuração.'));
  }

  private dataIso(data: Date): string {
    if (!data) {
      return '';
    }
    const dois = (numero: number) => (numero < 10 ? '0' : '') + numero;
    return data.getFullYear() + '-' + dois(data.getMonth() + 1) + '-' + dois(data.getDate());
  }

  private aplicarFiltroGeral(): void {
    const texto = this.normalizar(this.filtroGeral);
    const origemEmpresas = this.empresasSincronizadas;
    this.empresasGrade = origemEmpresas.filter(item => this.contem(
      [item.codEmpresa, item.nome, item.cnpj, item.codDealer, item.ambiente, item.ativo, item.rotulo, item.situacao, item.mensagem],
      texto
    ));
    this.operacoesGrade = this.operacoesSincronizadas.filter(item => this.contem(
      [item.codOperacao, item.descricao, item.contrato, item.horario, item.ativo, item.rotulo, item.codDealer, item.situacao, item.mensagem],
      texto
    ));
    this.cruzamentosGrade = this.cruzamentosSincronizados.filter(item => this.contem(
      [item.codDealer, item.codEmpresa, item.nomeDealer, item.codOperacao, item.operacao, item.ativo ? 'Ativo' : 'Inativo', item.configurado, item.situacao, item.mensagem],
      texto
    ));
    this.clientesGrade = this.clientesCarregados.filter(item => this.contem(
      [item.codMovimento, item.nomeEmpresa, item.codCliente, item.nome, item.dataCadastro, item.tipoPessoa, this.rotuloEnviado(item.enviado), item.status, item.dataIntegracao, item.dataUltimaAtualizacao, item.errosEnvio, item.marca],
      texto
    ));
    this.produtivosGrade = this.produtivosCarregados.filter(item => this.contem(
      [item.codMovimento, item.nomeEmpresa, item.codTecnico, item.nome, item.cpf, item.dataAdmissao, this.rotuloEnviado(item.enviado), item.status, item.dataIntegracao, item.dataUltimaAtualizacao, item.errosEnvio, item.marca],
      texto
    ));
    this.comprasGrade = this.comprasCarregados.filter(item => this.contem(
      [item.codMovimento, item.nomeEmpresa, item.codControle, item.numero, item.serie, item.dataEmissao, item.cliente, item.operacao, this.rotuloEnviado(item.enviado), item.status, item.dataIntegracao, item.dataUltimaAtualizacao, item.errosEnvio, item.marca],
      texto
    ));
    this.balcaoGrade = this.balcaoCarregados.filter(item => this.contem(
      [item.codMovimento, item.nomeEmpresa, item.numero, item.serie, item.dataEmissao, item.vendedor, item.cpfVendedor, item.cliente, item.operacao, this.rotuloEnviado(item.enviado), item.status, item.dataIntegracao, item.dataUltimaAtualizacao, item.errosEnvio, item.marca],
      texto
    ));
    this.ordensGrade = this.ordensCarregados.filter(item => this.contem(
      [item.codMovimento, item.nomeEmpresa, item.numeroOs, item.idNumeroOs, item.descTipoOs, item.consultor, item.cliente, this.rotuloEnviado(item.enviado), item.status, item.dataIntegracao, item.dataUltimaAtualizacao, item.errosEnvio, item.marca],
      texto
    ));
    this.codigosOperacaoExtra.forEach(codigo => {
      const base = this.operacoesCarregadas[codigo] || [];
      this.operacoesMonitorGrade[codigo] = base.filter(item => this.contem(this.valoresOperacao(item), texto));
    });
    this.operacoesMonitorGrade = { ...this.operacoesMonitorGrade };
    this.operacoes.forEach(operacao => {
      const base = this.movimentosExibidos[operacao.codOperacao] || [];
      this.movimentosGrade[operacao.codOperacao] = base.filter(item => this.contem(
        [item.codMovimento, item.empresa, item.registro, item.descricao, item.status, item.dataIntegracao, item.dataUltimaAtualizacao, item.errosEnvio],
        texto
      ));
    });
    this.movimentosGrade = { ...this.movimentosGrade };
  }

  private contem(valores: any[], texto: string): boolean {
    if (!texto) {
      return true;
    }
    return valores.some(valor => this.normalizar(this.textoDe(valor)).includes(texto));
  }

  private textoDe(valor: any): string {
    if (valor == null) {
      return '';
    }
    if (valor instanceof Date) {
      return this.formatarData(valor);
    }
    if (typeof valor === 'boolean') {
      return valor ? 'sim' : 'nao';
    }
    return String(valor);
  }

  private normalizar(valor: string): string {
    return (valor || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  private formatarData(data: Date): string {
    const dois = (numero: number) => (numero < 10 ? '0' : '') + numero;
    return dois(data.getDate()) + '/' + dois(data.getMonth() + 1) + '/' + data.getFullYear()
      + ' ' + dois(data.getHours()) + ':' + dois(data.getMinutes()) + ':' + dois(data.getSeconds());
  }

  private prepararMonitor(codOperacao: number): void {
    this.filtrosMonitor[codOperacao] = this.filtroVazio();
    this.movimentosExibidos[codOperacao] = this.movimentos.filter(item => item.codOperacao === codOperacao);
  }

  private filtroVazio(): FiltroMonitor {
    return {
      empresas: [],
      status: null,
      tipoData: null,
      dataInicial: null,
      dataFinal: null,
      registro: '',
      descricao: '',
      tipoPessoa: null
    };
  }

  private filtroClientePadrao(): FiltroMonitor {
    const hoje = this.inicioDoDia(new Date());
    return {
      ...this.filtroVazio(),
      tipoData: 'integracao',
      dataInicial: hoje,
      dataFinal: hoje
    };
  }

  private carregarClientes(): void {
    const filtro = this.filtrosMonitor[8] || this.filtroClientePadrao();
    this.filtrosMonitor[8] = filtro;
    if (!filtro.empresas || !filtro.empresas.length) {
      this.clientesCarregados = [];
      this.aplicarFiltroGeral();
      return;
    }
    this.iniciarCarga();
    this.extratorService.listarClientes({
      empresas: filtro.empresas,
      status: filtro.status,
      tipoPessoa: filtro.tipoPessoa,
      codigo: filtro.registro,
      nome: filtro.descricao,
      tipoData: filtro.tipoData,
      dataInicial: this.dataIso(filtro.dataInicial),
      dataFinal: this.dataIso(filtro.dataFinal)
    }).subscribe(clientes => {
      this.clientesCarregados = clientes || [];
      this.aplicarFiltroGeral();
      this.finalizarCarga();
    }, () => {
      this.finalizarCarga();
      this.avisar('Não foi possível consultar os clientes do Monitor.');
    });
  }

  private carregarProdutivos(): void {
    const filtro = this.filtrosMonitor[9] || this.filtroClientePadrao();
    this.filtrosMonitor[9] = filtro;
    if (!filtro.empresas || !filtro.empresas.length) {
      this.produtivosCarregados = [];
      this.aplicarFiltroGeral();
      return;
    }
    this.iniciarCarga();
    this.extratorService.listarProdutivos({
      empresas: filtro.empresas,
      status: filtro.status,
      cpf: filtro.registro,
      nome: filtro.descricao,
      tipoData: filtro.tipoData,
      dataInicial: this.dataIso(filtro.dataInicial),
      dataFinal: this.dataIso(filtro.dataFinal)
    }).subscribe(produtivos => {
      this.produtivosCarregados = produtivos || [];
      this.aplicarFiltroGeral();
      this.finalizarCarga();
    }, () => {
      this.finalizarCarga();
      this.avisar('Não foi possível consultar os produtivos do Monitor.');
    });
  }

  private carregarCompras(): void {
    const filtro = this.filtrosMonitor[12] || this.filtroClientePadrao();
    this.filtrosMonitor[12] = filtro;
    if (!filtro.empresas || !filtro.empresas.length) {
      this.comprasCarregados = [];
      this.aplicarFiltroGeral();
      return;
    }
    this.iniciarCarga();
    this.extratorService.listarCompras({
      empresas: filtro.empresas,
      status: filtro.status,
      numero: filtro.registro,
      codControle: filtro.descricao,
      tipoData: filtro.tipoData,
      dataInicial: this.dataIso(filtro.dataInicial),
      dataFinal: this.dataIso(filtro.dataFinal)
    }).subscribe(compras => {
      this.comprasCarregados = compras || [];
      this.aplicarFiltroGeral();
      this.finalizarCarga();
    }, () => {
      this.finalizarCarga();
      this.avisar('Não foi possível consultar as compras do Monitor.');
    });
  }

  private carregarBalcao(): void {
    const filtro = this.filtrosMonitor[7] || this.filtroClientePadrao();
    this.filtrosMonitor[7] = filtro;
    if (!filtro.empresas || !filtro.empresas.length) {
      this.balcaoCarregados = [];
      this.aplicarFiltroGeral();
      return;
    }
    this.iniciarCarga();
    this.extratorService.listarBalcao({
      empresas: filtro.empresas,
      status: filtro.status,
      numero: filtro.registro,
      cpf: filtro.descricao,
      tipoData: filtro.tipoData,
      dataInicial: this.dataIso(filtro.dataInicial),
      dataFinal: this.dataIso(filtro.dataFinal)
    }).subscribe(itens => {
      this.balcaoCarregados = itens || [];
      this.aplicarFiltroGeral();
      this.finalizarCarga();
    }, () => {
      this.finalizarCarga();
      this.avisar('Não foi possível consultar as vendas de balcão do Monitor.');
    });
  }

  private carregarOperacoesExtra(): void {
    this.codigosOperacaoExtra.forEach(codigo => this.carregarOperacaoExtra(codigo));
  }

  private carregarOperacaoExtra(codigo: number): void {
    const filtro = this.filtrosMonitor[codigo] || this.filtroClientePadrao();
    this.filtrosMonitor[codigo] = filtro;
    if (!filtro.empresas || !filtro.empresas.length) {
      this.operacoesCarregadas[codigo] = [];
      this.aplicarFiltroGeral();
      return;
    }
    this.iniciarCarga();
    this.extratorService.listarOperacao({
      codOperacao: codigo,
      empresas: filtro.empresas,
      status: filtro.status,
      registro: filtro.registro,
      descricao: filtro.descricao,
      tipoData: filtro.tipoData,
      dataInicial: this.dataIso(filtro.dataInicial),
      dataFinal: this.dataIso(filtro.dataFinal)
    }).subscribe(itens => {
      this.operacoesCarregadas[codigo] = itens || [];
      this.aplicarFiltroGeral();
      this.finalizarCarga();
    }, () => {
      this.finalizarCarga();
      this.avisar('Não foi possível consultar o Monitor.');
    });
  }

  gradeOperacao(codigo: number): OperacaoMonitor[] {
    return this.operacoesMonitorGrade[codigo] || [];
  }

  colunasOperacao(codigo: number): ColunaMonitor[] {
    const comum: ColunaMonitor[] = [
      { campo: 'nomeEmpresa', titulo: 'Empresa' },
      { campo: 'enviado', titulo: 'Enviado', tipo: 'enviado' },
      { campo: 'status', titulo: 'Status', tipo: 'status' },
      { campo: 'dataIntegracao', titulo: 'Data integração' },
      { campo: 'dataUltimaAtualizacao', titulo: 'Última atualização' },
      { campo: 'errosEnvio', titulo: 'Erros envio' },
      { campo: 'marca', titulo: 'Marca' }
    ];
    const especificas: { [codigo: number]: ColunaMonitor[] } = {
      14: [{ campo: 'partNumber', titulo: 'Part Number' }],
      15: [{ campo: 'partNumber', titulo: 'Part Number' }],
      17: [{ campo: 'codProposta', titulo: 'Cód. Proposta' }, { campo: 'statusProposta', titulo: 'Status Proposta' }],
      18: [{ campo: 'numeroPedido', titulo: 'Número Pedido' }],
      22: [
        { campo: 'numeroOs', titulo: 'Número O.S.' },
        { campo: 'idNumeroOs', titulo: 'ID Número O.S.' },
        { campo: 'partNumber', titulo: 'Cód. Item' },
        { campo: 'codFornecedor', titulo: 'Cód. Fornecedor' },
        { campo: 'sequencia', titulo: 'Sequência' }
      ],
      24: [{ campo: 'codEvento', titulo: 'Cód. Evento' }, { campo: 'statusEvento', titulo: 'Status evento' }],
      32: [{ campo: 'numeroOs', titulo: 'Núm. OS' }, { campo: 'codCliente', titulo: 'Cód. Cliente' }],
      33: [{ campo: 'numeroOs', titulo: 'Número OS' }, { campo: 'statusOs', titulo: 'Status OS' }],
      34: [{ campo: 'codMtoc', titulo: 'Cód. MTOC' }]
    };
    return [{ campo: 'codMovimento', titulo: 'Cód. Movimento' }].concat(comum.slice(0, 1), especificas[codigo] || [], comum.slice(1));
  }

  valorColuna(item: OperacaoMonitor, coluna: ColunaMonitor): string {
    if (!item || !coluna) {
      return '';
    }
    if (coluna.tipo === 'enviado') {
      return this.rotuloEnviado(item.enviado);
    }
    const valor = item[coluna.campo as keyof OperacaoMonitor];
    return valor === null || valor === undefined || valor === '' ? '-' : String(valor);
  }

  rotuloFiltroRegistro(codigo: number): string {
    const rotulos = {
      14: 'Part Number',
      15: 'Part Number',
      17: 'Cód. Proposta',
      18: 'Número Pedido',
      22: 'Número O.S.',
      24: 'Cód. Evento',
      32: 'Núm. OS',
      33: 'Número OS',
      34: 'Cód. MTOC'
    };
    return rotulos[codigo] || '';
  }

  quantidadeStatusOperacao(codigo: number, status: string): number {
    return this.gradeOperacao(codigo).filter(item => item.status === status).length;
  }

  private valoresOperacao(item: OperacaoMonitor): any[] {
    return this.colunasOperacao(item.codOperacao).map(coluna => coluna.tipo === 'enviado' ? this.rotuloEnviado(item.enviado) : item[coluna.campo as keyof OperacaoMonitor]);
  }

  private carregarOs(): void {
    const filtro = this.filtrosMonitor[10] || this.filtroClientePadrao();
    this.filtrosMonitor[10] = filtro;
    if (!filtro.empresas || !filtro.empresas.length) {
      this.ordensCarregados = [];
      this.aplicarFiltroGeral();
      return;
    }
    this.iniciarCarga();
    this.extratorService.listarOs({
      empresas: filtro.empresas,
      status: filtro.status,
      numeroOs: filtro.registro,
      idNumeroOs: filtro.descricao,
      tipoData: filtro.tipoData,
      dataInicial: this.dataIso(filtro.dataInicial),
      dataFinal: this.dataIso(filtro.dataFinal)
    }).subscribe(itens => {
      this.ordensCarregados = itens || [];
      this.aplicarFiltroGeral();
      this.finalizarCarga();
    }, () => {
      this.finalizarCarga();
      this.avisar('Não foi possível consultar as ordens de serviço do Monitor.');
    });
  }

  rotuloEnviado(valor: string): string {
    if (valor === 'S') {
      return 'Sim';
    }
    if (valor === 'N') {
      return 'Não';
    }
    if (valor === 'A') {
      return 'Erro';
    }
    return valor || '';
  }

  classeStatus(status: string): string {
    if (status === 'Dados inválidos') {
      return 'invalido';
    }
    const item = this.legendaStatus.find(legenda => legenda.status === status);
    return item ? item.classe : '';
  }

  quantidadeStatus(status: string): number {
    return this.clientesGrade.filter(item => item.status === status).length;
  }

  quantidadeStatusProdutivo(status: string): number {
    return this.produtivosGrade.filter(item => item.status === status).length;
  }

  quantidadeStatusCompra(status: string): number {
    return this.comprasGrade.filter(item => item.status === status).length;
  }

  quantidadeStatusBalcao(status: string): number {
    return this.balcaoGrade.filter(item => item.status === status).length;
  }

  quantidadeStatusOs(status: string): number {
    return this.ordensGrade.filter(item => item.status === status).length;
  }

  textoSemTentativa(): string {
    if (this.clienteDetalhe) {
      return 'Nenhuma tentativa publicada para este cliente.';
    }
    if (this.produtivoDetalhe) {
      return 'Nenhuma tentativa publicada para este produtivo.';
    }
    if (this.balcaoDetalhe) {
      return 'Nenhuma tentativa publicada para esta venda de balcão.';
    }
    if (this.osDetalhe) {
      return 'Nenhuma tentativa publicada para esta ordem de serviço.';
    }
    return 'Nenhuma tentativa publicada para esta compra.';
  }

  abrirMenuReenvio(menu: { toggle: (evento: Event) => void }, evento: Event, codOperacao: number): void {
    this.operacaoReenvio = codOperacao;
    menu.toggle(evento);
  }

  reenviarCliente(cliente: ClienteMonitor): void {
    if (!cliente || !cliente.codDealer || !cliente.codMovimento) {
      this.avisar('Cliente sem movimento para reenviar.');
      return;
    }
    this.confirmationService.confirm({
      message: `Marcar o cliente ${cliente.codCliente} - ${cliente.nome} para reenvio?`,
      header: 'Reenviar',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Reenviar',
      rejectLabel: 'Cancelar',
      accept: () => this.enviarReenvio([cliente.codDealer], 'UM', cliente.codMovimento, 8, 0, cliente)
    });
  }

  reenviarProdutivo(produtivo: ProdutivoMonitor): void {
    if (!produtivo || !produtivo.codDealer || !produtivo.codMovimento) {
      this.avisar('Produtivo sem movimento para reenviar.');
      return;
    }
    this.confirmationService.confirm({
      message: `Marcar o técnico ${produtivo.codTecnico} - ${produtivo.nome} para reenvio?`,
      header: 'Reenviar',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Reenviar',
      rejectLabel: 'Cancelar',
      accept: () => this.enviarReenvio([produtivo.codDealer], 'UM', produtivo.codMovimento, 9, 0, produtivo)
    });
  }

  reenviarCompra(compra: CompraMonitor): void {
    if (!compra || !compra.codDealer || !compra.codMovimento) {
      this.avisar('Compra sem movimento para reenviar.');
      return;
    }
    this.confirmationService.confirm({
      message: `Marcar a compra ${compra.numero} / ${compra.serie} para reenvio?`,
      header: 'Reenviar',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Reenviar',
      rejectLabel: 'Cancelar',
      accept: () => this.enviarReenvio([compra.codDealer], 'UM', compra.codMovimento, 12, 0, compra)
    });
  }

  reenviarBalcao(balcao: BalcaoMonitor): void {
    if (!balcao || !balcao.codDealer || !balcao.codMovimento) {
      this.avisar('Venda sem movimento para reenviar.');
      return;
    }
    this.confirmationService.confirm({
      message: `Marcar a venda ${balcao.numero} / ${balcao.serie} para reenvio?`,
      header: 'Reenviar',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Reenviar',
      rejectLabel: 'Cancelar',
      accept: () => this.enviarReenvio([balcao.codDealer], 'UM', balcao.codMovimento, 7, 0, balcao)
    });
  }

  reenviarOs(ordem: OsMonitor): void {
    if (!ordem || !ordem.codDealer || !ordem.codMovimento) {
      this.avisar('Ordem de serviço sem movimento para reenviar.');
      return;
    }
    this.confirmationService.confirm({
      message: `Marcar a O.S. ${ordem.numeroOs} para reenvio?`,
      header: 'Reenviar',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Reenviar',
      rejectLabel: 'Cancelar',
      accept: () => this.enviarReenvio([ordem.codDealer], 'UM', ordem.codMovimento, 10, 0, ordem)
    });
  }

  reenviarOperacao(item: OperacaoMonitor): void {
    if (!item || !item.codDealer || !item.codMovimento) {
      this.avisar('Movimento sem código para reenviar.');
      return;
    }
    this.confirmationService.confirm({
      message: `Marcar o movimento ${item.codMovimento} para reenvio?`,
      header: 'Reenviar',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Reenviar',
      rejectLabel: 'Cancelar',
      accept: () => this.enviarReenvio([item.codDealer], 'UM', item.codMovimento, item.codOperacao, 0, item)
    });
  }

  reenviarDetalhe(): void {
    if (this.operacaoDetalhe) {
      this.reenviarOperacao(this.operacaoDetalhe);
      return;
    }
    if (this.osDetalhe) {
      this.reenviarOs(this.osDetalhe);
      return;
    }
    if (this.balcaoDetalhe) {
      this.reenviarBalcao(this.balcaoDetalhe);
      return;
    }
    if (this.compraDetalhe) {
      this.reenviarCompra(this.compraDetalhe);
      return;
    }
    if (this.produtivoDetalhe) {
      this.reenviarProdutivo(this.produtivoDetalhe);
      return;
    }
    if (this.clienteDetalhe) {
      this.reenviarCliente(this.clienteDetalhe);
    }
  }

  confirmarReenvioLote(escopo: string): void {
    const operacao = this.operacaoReenvio;
    const dealers = this.dealersDoReenvio(escopo, operacao);
    const assunto = this.assuntoReenvio(operacao);
    if (!dealers.length) {
      this.avisar(escopo === 'BLOQUEADOS'
        ? `Não há ${assunto} bloqueados na lista.`
        : `Não há ${assunto} com erro na lista.`);
      return;
    }
    const alvo = escopo === 'BLOQUEADOS' ? 'bloqueados' : 'com erro';
    const revenda = dealers.length === 1 ? 'desta revenda' : `de ${dealers.length} revendas`;
    this.confirmationService.confirm({
      message: `Marcar para reenvio todos os ${assunto} ${alvo} ${revenda}? Vale para a base inteira, não só o período filtrado.`,
      header: 'Reenviar',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Reenviar',
      rejectLabel: 'Cancelar',
      accept: () => this.enviarReenvio(dealers, escopo, '', operacao)
    });
  }

  private dealersDoReenvio(escopo: string, operacao: number): string[] {
    const filtro = this.filtrosMonitor[operacao];
    if (filtro && filtro.empresas && filtro.empresas.length) {
      return filtro.empresas
        .map(item => item.codDealer)
        .filter((codigo, indice, lista) => !!codigo && lista.indexOf(codigo) === indice);
    }
    const status = escopo === 'BLOQUEADOS' ? 'Bloqueado' : 'Erro';
    const origem = this.movimentosDaOperacao(operacao);
    return origem
      .filter(item => item.status === status && !!item.codDealer)
      .map(item => item.codDealer)
      .filter((codigo, indice, lista) => lista.indexOf(codigo) === indice);
  }

  private enviarReenvio(dealers: string[], escopo: string, codMovimento: string, codOperacao: number, indice = 0, movimento: { enviado: string, errosEnvio: number, status: string } = null): void {
    if (indice >= dealers.length) {
      this.mensagem('Reenvio registrado. O serviço da revenda aplica na próxima execução.');
      return;
    }
    this.extratorService.reenviarCliente(dealers[indice], escopo, codMovimento, codOperacao).subscribe(() => {
      this.marcarPendente(dealers[indice], escopo, codOperacao, movimento);
      this.enviarReenvio(dealers, escopo, codMovimento, codOperacao, indice + 1, movimento);
    }, (erro) => this.avisarResposta(erro, 'Não foi possível registrar o reenvio.'));
  }

  private marcarPendente(codDealer: string, escopo: string, codOperacao: number, movimento: { enviado: string, errosEnvio: number, status: string }): void {
    if (escopo === 'UM') {
      if (movimento) {
        this.definirPendente(movimento);
      }
      return;
    }
    const origem = this.movimentosDaOperacao(codOperacao);
    origem.forEach(item => {
      if (item.codDealer !== codDealer) {
        return;
      }
      if (escopo === 'BLOQUEADOS' && item.status === 'Bloqueado') {
        this.definirPendente(item);
      }
      if (escopo === 'ERROS' && item.status === 'Erro') {
        this.definirPendente(item);
      }
    });
  }

  private definirPendente(movimento: { enviado: string, errosEnvio: number, status: string }): void {
    movimento.enviado = 'N';
    movimento.errosEnvio = 0;
    movimento.status = 'Pendente';
  }

  private assuntoReenvio(operacao: number): string {
    if (operacao === 9) {
      return 'produtivos';
    }
    if (operacao === 12) {
      return 'compras';
    }
    if (operacao === 7) {
      return 'vendas de balcão';
    }
    if (operacao === 10) {
      return 'ordens de serviço';
    }
    const assuntos = {
      14: 'itens de estoque',
      15: 'kardex',
      17: 'propostas',
      18: 'pedidos',
      22: 'requisições de item',
      24: 'leads',
      32: 'vendas pendentes',
      33: 'fichas de gerenciamento',
      34: 'planos de veículo'
    };
    return assuntos[operacao] || 'clientes';
  }

  private movimentosDaOperacao(codOperacao: number): { codDealer: string, status: string, enviado: string, errosEnvio: number }[] {
    if (codOperacao === 9) {
      return this.produtivosCarregados;
    }
    if (codOperacao === 12) {
      return this.comprasCarregados;
    }
    if (codOperacao === 7) {
      return this.balcaoCarregados;
    }
    if (codOperacao === 10) {
      return this.ordensCarregados;
    }
    if (this.operacaoExtra(codOperacao)) {
      return this.operacoesCarregadas[codOperacao] || [];
    }
    return this.clientesCarregados;
  }

  private limparDetalheAberto(): void {
    this.clienteDetalhe = null;
    this.produtivoDetalhe = null;
    this.compraDetalhe = null;
    this.balcaoDetalhe = null;
    this.osDetalhe = null;
    this.operacaoDetalhe = null;
    this.detalhesCliente = [];
    this.detalheSelecionado = null;
  }

  abrirDetalheCliente(cliente: ClienteMonitor): void {
    this.limparDetalheAberto();
    this.clienteDetalhe = cliente;
    this.detalhesCliente = [];
    this.detalheSelecionado = null;
    this.exibirDetalheCliente = true;
    this.extratorService.listarDetalheCliente(cliente.codDealer, cliente.codMovimento).subscribe(detalhes => {
      this.detalhesCliente = detalhes || [];
      this.detalheSelecionado = this.detalhesCliente.length ? this.detalhesCliente[0] : null;
    }, () => this.avisar('Não foi possível consultar o detalhe do cliente.'));
  }

  abrirDetalheProdutivo(produtivo: ProdutivoMonitor): void {
    this.limparDetalheAberto();
    this.produtivoDetalhe = produtivo;
    this.detalhesCliente = [];
    this.detalheSelecionado = null;
    this.exibirDetalheCliente = true;
    this.extratorService.listarDetalheProdutivo(produtivo.codDealer, produtivo.codMovimento).subscribe(detalhes => {
      this.detalhesCliente = detalhes || [];
      this.detalheSelecionado = this.detalhesCliente.length ? this.detalhesCliente[0] : null;
    }, () => this.avisar('Não foi possível consultar o detalhe do produtivo.'));
  }

  abrirDetalheCompra(compra: CompraMonitor): void {
    this.limparDetalheAberto();
    this.compraDetalhe = compra;
    this.detalhesCliente = [];
    this.detalheSelecionado = null;
    this.exibirDetalheCliente = true;
    this.extratorService.listarDetalheCompra(compra.codDealer, compra.codMovimento).subscribe(detalhes => {
      this.detalhesCliente = detalhes || [];
      this.detalheSelecionado = this.detalhesCliente.length ? this.detalhesCliente[0] : null;
    }, () => this.avisar('Não foi possível consultar o detalhe da compra.'));
  }

  abrirDetalheBalcao(balcao: BalcaoMonitor): void {
    this.limparDetalheAberto();
    this.balcaoDetalhe = balcao;
    this.exibirDetalheCliente = true;
    this.extratorService.listarDetalheBalcao(balcao.codDealer, balcao.codMovimento).subscribe(detalhes => {
      this.detalhesCliente = detalhes || [];
      this.detalheSelecionado = this.detalhesCliente.length ? this.detalhesCliente[0] : null;
    }, () => this.avisar('Não foi possível consultar o detalhe da venda de balcão.'));
  }

  abrirDetalheOs(ordem: OsMonitor): void {
    this.limparDetalheAberto();
    this.osDetalhe = ordem;
    this.exibirDetalheCliente = true;
    this.extratorService.listarDetalheOs(ordem.codDealer, ordem.codMovimento).subscribe(detalhes => {
      this.detalhesCliente = detalhes || [];
      this.detalheSelecionado = this.detalhesCliente.length ? this.detalhesCliente[0] : null;
    }, () => this.avisar('Não foi possível consultar o detalhe da ordem de serviço.'));
  }

  abrirDetalheOperacao(item: OperacaoMonitor): void {
    this.limparDetalheAberto();
    this.operacaoDetalhe = item;
    this.exibirDetalheCliente = true;
    this.extratorService.listarDetalheOperacao(item.codOperacao, item.codDealer, item.codMovimento).subscribe(detalhes => {
      this.detalhesCliente = detalhes || [];
      this.detalheSelecionado = this.detalhesCliente.length ? this.detalhesCliente[0] : null;
    }, () => this.avisar('Não foi possível consultar o detalhe.'));
  }

  selecionarDetalheCliente(detalhe: DetalheCliente): void {
    this.detalheSelecionado = detalhe;
  }

  textoDetalhe(valor: string): string {
    const texto = valor || '';
    const inicio = texto.trim().charAt(0);
    if (inicio !== '{' && inicio !== '[') {
      return texto;
    }
    try {
      return JSON.stringify(JSON.parse(texto), null, 2);
    } catch (erro) {
      return texto;
    }
  }

  copiarDetalhe(valor: string): void {
    const texto = this.textoDetalhe(valor);
    if (!texto.trim()) {
      this.avisar('Não há conteúdo para copiar.');
      return;
    }
    const area = document.createElement('textarea');
    area.value = texto;
    area.style.position = 'fixed';
    area.style.left = '-999999px';
    document.body.appendChild(area);
    area.focus();
    area.select();
    try {
      document.execCommand('copy');
      this.mensagem('Conteúdo copiado.');
    } catch (erro) {
      this.avisar('Não foi possível copiar o conteúdo.');
    } finally {
      document.body.removeChild(area);
    }
  }

  private movimentoAtendeFiltro(item: MovimentoExtrator, codOperacao: number, filtro: FiltroMonitor): boolean {
    if (item.codOperacao !== codOperacao) {
      return false;
    }
    if (!filtro.empresas || !filtro.empresas.length) {
      return false;
    }
    if (!filtro.empresas.some(empresa => empresa.codEmpresa === item.codEmpresa)) {
      return false;
    }
    if (filtro.status && item.status !== filtro.status) {
      return false;
    }
    if (filtro.registro && !item.registro.toLowerCase().includes(filtro.registro.trim().toLowerCase())) {
      return false;
    }
    if (filtro.descricao && !item.descricao.toLowerCase().includes(filtro.descricao.trim().toLowerCase())) {
      return false;
    }
    if (filtro.tipoData && (filtro.dataInicial || filtro.dataFinal)) {
      const data = filtro.tipoData === 'integracao' ? item.dataIntegracao : item.dataUltimaAtualizacao;
      const valor = this.inicioDoDia(data).getTime();
      if (filtro.dataInicial && valor < this.inicioDoDia(filtro.dataInicial).getTime()) {
        return false;
      }
      if (filtro.dataFinal && valor > this.inicioDoDia(filtro.dataFinal).getTime()) {
        return false;
      }
    }
    return true;
  }

  private inicioDoDia(data: Date): Date {
    return new Date(data.getFullYear(), data.getMonth(), data.getDate());
  }

  private data(dia: number, hora: number, minuto: number): Date {
    return new Date(2026, 9, dia, hora, minuto, 0);
  }

  private criarMovimento(
    codMovimento: number,
    codOperacao: number,
    empresa: EmpresaExtrator,
    registro: string,
    descricao: string,
    status: string,
    dataIntegracao: Date,
    dataUltimaAtualizacao: Date,
    errosEnvio: number
  ): MovimentoExtrator {
    return {
      codMovimento,
      codOperacao,
      codEmpresa: empresa.codEmpresa,
      empresa: `${empresa.codEmpresa} - ${empresa.nome}`,
      registro,
      descricao,
      status,
      dataIntegracao,
      dataUltimaAtualizacao,
      errosEnvio
    };
  }

  private criarEmpresa(
    codEmpresa: number,
    nome: string,
    cnpj: string,
    codDealer: string,
    ambiente: string,
    ativo: boolean
  ): EmpresaExtrator {
    return { codEmpresa, nome, cnpj, codDealer, ambiente, ativo, rotulo: `${codDealer} - ${codEmpresa} - ${nome}` };
  }

  private dealerDaNovaOperacao(): string {
    const empresas = this.empresasSincronizadas.filter(item => !!item.codDealer);
    const ativa = empresas.find(item => item.ativo);
    return (ativa || empresas[0] || { codDealer: '' }).codDealer;
  }

  private criarOperacao(codOperacao: number, descricao: string, contrato: number, horario: string, ativo: boolean): OperacaoExtrator {
    return { codOperacao, descricao, contrato, horario, ativo, rotulo: `${codOperacao} - ${descricao}` };
  }

  private criarCruzamento(
    id: number,
    empresa: EmpresaExtrator,
    operacao: OperacaoExtrator,
    ativo: boolean,
    urlHomologacao = '',
    urlProducao = ''
  ): CruzamentoExtrator {
    const configurado = this.urlsPreenchidas(urlHomologacao, urlProducao);
    return {
      id,
      codDealer: empresa.codDealer,
      codEmpresa: empresa.codEmpresa,
      nomeDealer: empresa.nome,
      codOperacao: operacao.codOperacao,
      operacao: operacao.descricao,
      ativo,
      configurado,
      configuracao: configurado ? {
        tipoIntegracao: 'Rest',
        usaDataInicio: false,
        dataInicio: null,
        urlHomologacao,
        urlProducao,
        idGrupoEmail: null,
        diasMonitor: 30
      } : null
    };
  }

  private urlsPreenchidas(urlHomologacao: string, urlProducao: string): boolean {
    const preenchida = (url: string) => !!(url && url.trim());
    return preenchida(urlHomologacao) || preenchida(urlProducao);
  }

  private configuracaoPadrao(): ConfiguracaoExtrator {
    return {
      tipoIntegracao: 'Rest',
      usaDataInicio: false,
      dataInicio: null,
      urlHomologacao: '',
      urlProducao: '',
      idGrupoEmail: null,
      diasMonitor: 30
    };
  }

  private operacaoVazia(): OperacaoExtrator {
    return { codOperacao: null, descricao: '', contrato: null, horario: '', ativo: true, visualizarMonitor: false, rotulo: '', codDealer: null };
  }

  private avisarResposta(erro: any, padrao: string): void {
    const texto = erro && erro.error ? erro.error : padrao;
    this.avisar(typeof texto === 'string' ? texto : padrao);
  }

  private atualizarDescricaoNosCruzamentos(operacao: OperacaoExtrator): void {
    this.cruzamentos.forEach(item => {
      if (item.codOperacao === operacao.codOperacao) {
        item.operacao = operacao.descricao;
      }
    });
    this.cruzamentos = [...this.cruzamentos];
  }

  private mensagem(detail: string): void {
    this.messageService.add({ severity: 'success', summary: 'Sucesso', detail });
  }

  private avisar(detail: string): void {
    this.messageService.add({ severity: 'warn', summary: 'Atenção', detail });
  }
}
